// src/services/parcoursService.js
import api from '../config/axiosConfig';

export const parcoursService = {
 
  async list() {
    const response = await api.get('master-parcours');
    return response.data; 
  },

  
  async getInvestigation(slug) {
    const response = await api.get(`investigation/${slug}`);
    return response.data; 
  },

 
  async getActiveParcours() {
    const response = await api.get('active-parcours');
    return response.data; 
  },

  
  async enroll(slug) {
    const response = await api.post(`enroll/${slug}`);
    return response.data; 
  },

  
  async sync(courseId, engineSnapshot) {
    const response = await api.post(`sync/${courseId}`, { state: engineSnapshot });
    return response.data;
  },
  

  async updateLegacyProgress(parcoursId, moduleId, payload) { 
    return await api.patch(`parcours/${parcoursId}/modules/${moduleId}/validate`, payload);
  },

  async unlockEngineerDiagram() {
    const response = await api.post('architect/unlock-sequence');
    return response.data;
  },
};